import React, { useContext } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import FormContext from 'src/presentation/contexts/FormContext';
import Textarea from 'src/presentation/components/forms/Textarea';

export const TextareaWithCharsCounter = ({ attr, maxLength, ...otherProps }) => {
  const { workingState } = useContext(FormContext);
  const value = get(workingState, attr, '');

  return (
    <>
      <StyledTextArea attr={attr} maxLength={maxLength} {...otherProps} />
      <SymbolsCounter>{maxLength - value.length} chars</SymbolsCounter>
    </>
  );
};

const StyledTextArea = styled(Textarea)`
  min-height: 66px;
`;

const SymbolsCounter = styled.div`
  color: ${p => p.theme.colors.gray800};
  font-size: 10px;
  position: absolute;
  right: 12px;
  top: 48px;
`;
